import React, { useState } from 'react';
import { UploadCloudIcon, HistoryIcon } from 'lucide-react';
import { LeadUploader } from './components/LeadUploader';
import { HistoryView } from './components/views/HistoryView';
import { cn } from './lib/utils';
type Tab = 'upload' | 'history';
export function App() {
  const [tab, setTab] = useState<Tab>('upload');
  return <div className="min-h-full w-full bg-gray-100" data-id="element-0" data-mp="3fb9jzcn93go5">
      {/* Salesforce-style app header */}
      <header className="border-b border-gray-200 bg-white" data-id="element-1" data-mp="2rlf5yrr73m2b">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-6" data-id="element-2" data-mp="2mmcbg18ucy8l">
          <div className="flex items-center justify-between py-4" data-id="element-3" data-mp="2mjzlb0sxjhkg">
            <div className="flex items-center gap-3" data-id="element-4" data-mp="31c9w477kb5t1">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-salesforce-500" data-id="element-5" data-mp="2wk9y4kb1ymz3">
                <UploadCloudIcon className="h-5 w-5 text-white" data-id="element-6" data-mp="28tw4wqgqei2x" />
              </div>
              <div data-id="element-7" data-mp="23vkwmk634fmt">
                <h1 className="text-lg font-bold leading-tight text-gray-900" data-id="element-8" data-mp="23w4gi6fape3h">
                  Custom Lead Uploader
                </h1>
                <p className="text-xs text-gray-500" data-id="element-9" data-mp="3ijpcgysnsv8p">
                  MortgagePros · Salesforce, Bonzo &amp; Five9
                </p>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <nav className="-mb-px flex gap-6" aria-label="Views" data-id="element-10" data-mp="3recdlirailf5">
            <TabButton active={tab === 'upload'} onClick={() => setTab('upload')} icon={UploadCloudIcon} label="Upload Leads" data-id="element-11" data-mp="4n53zyrel9i" />
            <TabButton active={tab === 'history'} onClick={() => setTab('history')} icon={HistoryIcon} label="Upload History" data-id="element-12" data-mp="33nq921ghvj9w" />
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6 sm:py-8" data-id="element-13" data-mp="3dirxsw6uyjby">
        {tab === 'upload' ? <LeadUploader data-id="element-14" data-mp="nxn4pq48izmb" /> : <HistoryView data-id="element-15" data-mp="sunas11342df" />}
      </main>
    </div>;
}
function TabButton({
  active,
  onClick,
  icon: Icon,
  label
}: {
  active: boolean;
  onClick: () => void;
  icon: React.ElementType;
  label: string;
}) {
  return <button type="button" onClick={onClick} className={cn('flex items-center gap-2 border-b-2 pb-3 pt-1 text-sm font-semibold transition-colors', active ? 'border-salesforce-500 text-salesforce-700' : 'border-transparent text-gray-500 hover:text-gray-800')} data-id="element-16" data-mp="3uday0bte0t6a">
      <Icon className="h-4 w-4" data-id="element-17" data-mp="3gm647qcpav3v" />
      {label}
    </button>;
}